import api from "../utils/axiosInstance";
import { ToastError, ToastSuccess } from "../CustomToaster/CustomToaster";
import { logoutUserApi, userLogout } from "../Actions/AuthAction";
import { removeUserDetailData } from "../Actions/UserDetailAction";
import dayjs from "dayjs";
import axios from "axios";
// import { persistor } from "../../store/index.js";

export const userRegister = async (data) => {
   try {
      const response = await api.post(`/register`, data)
      return response
   }
   catch (error) {
      return error
   }

}

// export const AccountVerify=async(data)=>{


//       try{
//        const response= await api.post(`${BACKEND_URL}/account-verify`,data)
//        return response
//       }
//       catch(error){
//        return error
//       }

//    }

export const forgotPassword = async (data) => {


   try {
      const response = await api.post(`/forgot-password`, data)
      return response
   }
   catch (error) {
      return error
   }

}

export const VerifyOtp = async (data) => {
   try {
      const response = await api.post(`/verify`, data)
      return response
   }
   catch (error) {
      return error
   }
}

export const resendOtp = async (data) => {
   try {
      const response = await api.post(`/resend-otp`, data)
      return response
   }
   catch (error) {
      return error
   }
}

// export const PreChecker=async(data)=>{
//    try{
//       const response= await api.post(`${BACKEND_URL}/pre-check`,data)
//       return response
//      }
//      catch(error){
//       return error
//      }
// }

export const ResetPassword = async (data) => {
   try {
      const response = await api.post(`/reset-password`, data)
      return response
   }
   catch (error) {
      return error
   }
}

export const TfaVerify = async (data) => {
   try {
      const response = await api.post(`/user/2fa-verify`, data)
      return response
   }
   catch (error) {
      return error
   }
}

export const changePassword = async (data) => {
   try {
      const response = await api.post(`/user/change-password`, data)
      return response
   }
   catch (error) {
      return error
   }
}

export const handleLogout = async (sidToLogout, dispatch, setLoginSessions = null, navigate = null) => {
   if (!sidToLogout) return;
   const response = await dispatch(logoutUserApi(sidToLogout));
   if (response?.success) {
      ToastSuccess({ message: response.message });

      // ✅ Update the status and logoutAt in UI immediately without refresh
      if (setLoginSessions) {
         setLoginSessions((prevRows) =>
            prevRows.map((row) =>
               row.full.sid === sidToLogout
                  ? {
                     ...row,
                     status: "inactive",
                     logoutAt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
                     full: {
                        ...row.full,
                        status: "inactive",
                        logoutAt: new Date().toISOString(), // raw format for possible re-use
                     },
                  }
                  : row
            )
         );
      }

      // ✅ Handle current session logout
      const currentSid = localStorage.getItem("sid");
      if (sidToLogout === currentSid) {
         localStorage.clear();
         sessionStorage.clear();
         // persistor.purge();
         dispatch(userLogout());
         dispatch(removeUserDetailData());
         if (navigate) {
            navigate("/login")
         } else {
            window.location.href = "/login";
         }
      }
   } else {
      ToastError({ message: response.message || "Logout failed" });
   }
};


export const getIpAddress = async (data) => {


   try {
      const response = await axios.get('https://api.ipify.org?format=json')
      return response
   }
   catch (error) {
      return error
   }
}